module.exports = __webpack_public_path__ + "img/file-excel-fill.eefcc57b.svg";